import React, { useEffect, useState } from 'react';
import { FileText, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../api';
import { Card, SectionTitle } from '../ui';

const MONTHS = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
const name = (m) => `${MONTHS[Number(m.slice(5, 7)) - 1]} ${m.slice(0, 4)}`;

export default function StatementsCard() {
  const [months, setMonths] = useState([]);
  const [busy, setBusy] = useState('');
  useEffect(() => { api.get('/wallet/statements').then((r) => setMonths(r.data)).catch(() => {}); }, []);
  const download = async (m) => {
    setBusy(m);
    try {
      const r = await api.get('/wallet/statements/pdf', { params: { month: m }, responseType: 'blob' });
      const a = document.createElement('a'); a.href = URL.createObjectURL(r.data); a.download = `BOND_estratto_${m}.pdf`; a.click(); URL.revokeObjectURL(a.href);
    } catch { toast.error('Download non riuscito'); } finally { setBusy(''); }
  };
  if (!months.length) return null;
  const current = new Date().toISOString().slice(0, 7);
  return (
    <Card className="p-6 mb-8" data-testid="statements-card">
      <SectionTitle>Estratti mensili</SectionTitle>
      <p className="text-xs text-[#7A7F87] mb-4">Riepilogo dei servizi usati e degli importi di ogni mese. Lo ricevi anche via email il 1° del mese successivo.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2">
        {months.map((m) => (
          <button key={m} onClick={() => download(m)} disabled={!!busy} data-testid={`statement-${m}`}
            className="h-12 px-4 border border-[#1F242C] rounded-sm flex items-center gap-2 text-sm text-left hover:border-[#D4AF37] transition-colors">
            {busy === m ? <Loader2 size={14} className="animate-spin text-[#D4AF37]" /> : <FileText size={14} className="text-[#D4AF37]" />}
            <span className="flex-1">{name(m)}</span>{m === current && <span className="text-[10px] uppercase text-[#7A7F87]">in corso</span>}
          </button>
        ))}
      </div>
    </Card>
  );
}
